const errors = {
    "TEST_NOT_VALID_BY_EMAIL": "Teste não disponível. Já foi gerada uma conta de teste anteriormente para você. Entre em contato com um representante.",
    "TEST_NOT_VALID_BY_PHONE": "Teste não disponível. Já foi gerada uma conta de teste anteriormente para você. Entre em contato com um representante.",
    "TEST_NOT_VALID_BY_USERNAME": "Teste não disponível. Já foi gerada uma conta de teste anteriormente para você. Entre em contato com um representante.",
    "LOGIN_OR_PASS_INVALID": "Desculpe, as credenciais que você está usando são inválidas.",
    "LOGIN_NOT_ACTIVE": "Seu acesso não está ativo no momento, por favor, entre em contato com o suporte",
    "OFFICE_NOT_ACTIVE": "Seu acesso não está ativo no momento, por favor, entre em contato com o suporte",
    "RESET_IDENTIFIER_REQUIRED": "Informe seu login ou e-mail para recuperar a senha.",
    "PASSWORD_RESET_UNAVAILABLE": "Não foi possível processar a recuperação para este usuário.",
    "PASSWORD_RESET_EMAIL_SENT": "Se os dados informados estiverem corretos, você receberá um link para redefinição de senha no e-mail cadastrado.",
    "PASSWORD_RESET_EMAIL_ERROR": "Não foi possível enviar o e-mail de redefinição agora. Tente novamente em instantes.",
    "PASSWORD_RESET_TOKEN_INVALID": "O link de redefinição é inválido.",
    "PASSWORD_RESET_TOKEN_EXPIRED": "O link de redefinição expirou. Solicite um novo.",
    "PASSWORD_TOO_WEAK": "A nova senha deve conter letras, números e no mínimo 8 caracteres.",
    "PASSWORD_CONFIRM_MISMATCH": "A confirmação da senha não confere.",
    "PASSWORD_RESET_SUCCESS": "Senha redefinida com sucesso. Faça login com sua nova senha.",
    "PASSWORD_RESET_GENERAL_ERROR": "Não foi possível redefinir a senha neste momento.",
    "CLIENT_GENERAL_ERROR": "Ocorreu um erro ao gravar o cliente",
    "CLIENT_NO_DATA_TO_UPDATE":"Ops. Você não informou os novos dados do cliente."
}

export default (key) => {
    return errors[key] || key;
}


// WEBPACK FOOTER //
// ./src/js/services/getConstants.js